import { render, staticRenderFns } from "./EditProjectModal.vue?vue&type=template&id=80d32a14&scoped=true&"
import script from "./EditProjectModal.vue?vue&type=script&lang=js&"
export * from "./EditProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectModal.vue?vue&type=style&index=0&id=80d32a14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d32a14",
  null
  
)

export default component.exports